<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Modal, Button, Text, Container } from '@Shelly/shelly-design-system';
	import { handleLogout } from 'src/helpers/account_helpers';
	import { user_data } from 'src/stores/account/user';
	import { profiles } from 'src/stores/features/profiles';
	import { mobile } from 'src/services/mobile-rework';
	import { get } from 'svelte/store';
	import { capFirstChar } from 'src/helpers/utilities';
	import { createEventDispatcher, onMount } from 'svelte';
	import { globalLoaderMsg, showGlobalLoader } from 'src/stores/ui/global-loader';
	import { resetDrawer } from 'src/helpers/drawer_helpers';

	const _format = get(format);
	const dispatch = createEventDispatcher();

	export let showModal = false;
	export let title = `${_format('label_profile_logout_title', {
		default: 'Log Out From Profile',
	})}?`;
	export let logoutFromAllProfiles = false;

	let isLoading = false;

	const onCloseModal = () => {
		if (isLoading) return;
		showModal = false;
		logoutFromAllProfiles = false;
	};

	const handleLogoutRequest = async (msg: string, logoutAllProfiles: boolean) => {
		onCloseModal();
		resetDrawer('login');
		$showGlobalLoader = true;
		$globalLoaderMsg = msg;
		const result = await handleLogout(undefined, logoutAllProfiles);
		$showGlobalLoader = false;
		$globalLoaderMsg = '';
		if (result && 'pendingUnitSelection' in result) {
			dispatch('selectUnit', result);
		}
	};

	const onLogoutProfile = async () => {
		if (logoutFromAllProfiles) {
			handleLogoutRequest(
				_format('loggin_out_all_profile_loading_msg', {
					default: 'Logging out from all profile...',
				}),
				true,
			);
		} else if ($profiles.length > 2) {
			dispatch('logout');
		} else {
			handleLogoutRequest(
				_format('loggin_out_profile_loading_msg', {
					default: 'Logging out from profile...',
				}),
				false,
			);
		}
	};

	const closeModal = (e: CustomEvent) => {
		if (showModal) {
			e.preventDefault();
			showModal = false;
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});
</script>

<Modal on:close={onCloseModal} {title} {showModal}>
	<Container slot="content" padding="0">
		<Text>
			{logoutFromAllProfiles
				? $format('label_all_profiles_logout_title', {
						default: 'Are you sure you want to log out from all of your profiles',
					})
				: $format('text_modal_logout_msg', {
						values: {
							prop: $user_data.email,
						},
						default: 'Are you sure you want to log out from your profile ‘{prop}’',
					})}?
		</Text>
	</Container>

	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			variant="secondary"
			disabled={isLoading}
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onCloseModal}
		>
			{capFirstChar(_format('button_cancel', { default: 'cancel' }))}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			loading={isLoading}
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onLogoutProfile}
		>
			{capFirstChar(_format('logout', { default: 'Log out' }))}
		</Button>
	</div>
</Modal>
